import * as React from 'react'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { red } from '@mui/material/colors'

const MapMaker = ({ rname, image, lat, lng, onClick }) => (
  <div data-lat={lat} data-lng={lng} onClick={onClick}>
    <Stack direction="row" spacing={1} sx={{ bgcolor: red[500] }}>
      <Chip
        avatar={
          <Avatar alt="Natacha" src={`https://roadjockey.com/img/${image}`} />
        }
      />
      <span
        onClick={onClick}
        className="badge"
        style={{ fontWeight: 'bold', fontSize: '13px' }}
      >
        {rname}
      </span>
    </Stack>
  </div>
)

export default MapMaker
